import { useContext, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RootStoreContext } from '../App';

const MqttNavigation = () => {
	const { mqttStore } = useContext(RootStoreContext);
	const navigate = useNavigate();

	useLayoutEffect(() => {
		mqttStore.setNavigate(navigate);
		return () => mqttStore.setNavigate(null);
	}, [mqttStore, navigate]);

	return null;
};

export default MqttNavigation;
